import React from 'react';
import ReactDOM from 'react-dom';
import { MenuContent } from '@menu/components';

const renderMenu = (element, mobile) => {
  const data = $(element).data('menu-data');

  ReactDOM.render(
    <MenuContent
      menuContent={data}
      mobile={mobile}
    />,
    element
  );
};

$('html').on('consumer.dependencies.loaded', () => {
  const desktopMenuElement = document.getElementById('menu-content');
  if (desktopMenuElement) renderMenu(desktopMenuElement, false);

  const mobileMenuElement = document.getElementById('menu-content-mobile');
  if (mobileMenuElement) renderMenu(mobileMenuElement, true);
});
